module.exports = __webpack_public_path__ + "img/player-bag.d0603ef2.png";